import { openPledgesPage } from '../pledges/runtime-registry';
import { getManagerNavAction } from '../manager-nav-registry.js';
import { getMemberNavAction } from '../../members/member-nav-registry.js';
import { opCfg, opIsMemberSession } from './config.js';

export function resolveOpenCreditAfterClose() {
    const explicit = opCfg().afterClose;
    if (explicit) {
        return explicit;
    }
    if (opIsMemberSession()) {
        return 'accountSettings';
    }
    const $root = $('#mgr_index_paging');
    if ($root.find('.members-open-credits-page').length) {
        return 'openCredits';
    }
    if ($root.find('.member-profile-manager-page').length) {
        return 'memberProfile';
    }
    if ($root.find('.pledges-manager-page').length) {
        return 'pledges';
    }
    if ($root.find('.members-manager-page').length) {
        return 'members';
    }
    return 'none';
}

export function runAfterCloseAction(after, uid) {
    if (after === 'openCredits' && uid) {
        getManagerNavAction('viewMemberOpenCreditDetails')(uid);
        return;
    }
    if (after === 'memberProfile' && uid) {
        getManagerNavAction('openMemberProfilePage')(uid);
        return;
    }
    if (after === 'members') {
        getManagerNavAction('OpenMembersPage')();
        return;
    }
    if (after === 'pledges') {
        openPledgesPage();
        return;
    }
    if (after === 'accountSettings') {
        getMemberNavAction('openAccountSettings')('payment');
    }
}
